export default "__VITE_ASSET__BsBOXZH1__"